import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_EDIT,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_REPLACE,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  CLIENT_TYPE_CONST,
} from "constants/FormatDataContanst";
import {
  DEFAULT_NULL_NUMBER,
  TCHAT_VALUES,
} from "constants/IssueInvoiceConstant";
import {
  financial,
  getDecimalScaleByUnitCurrency,
  invoicePosPageViewList,
  isEmptyNumber,
} from "../utils";

export const getInvoiceStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: t("auth_status.init"),
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      //"Chờ phát hành"
      text: t("auth_status.progressing"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_REJECT]: {
      //"Thuế từ chối duyệt",
      text: t("auth_status.reject"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_APPROVE]: {
      //"Đã phát hành",
      text: t("auth_status.approve"),
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_REPLACE]: {
      //"Thay thế",
      text: t("auth_status.replace"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_EDIT]: {
      //"Điều chỉnh",
      text: t("auth_status.edit"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_CANCEL]: {
      //"Hủy",
      text: t("auth_status.cancel"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_CANCEL_WAITING]: {
      //"Hủy",
      text: "Chờ duyệt hủy",
      badgeColor: "badge-soft-warning",
    },

    [AUTH_STATUS_REJECT_CANCEL]: {
      //"Từ chối hủy",
      text: "Từ chối hủy",
      badgeColor: "badge-soft-danger",
    },

    [AUTH_STATUS_RR]: {
      //"Từ chối tiếp nhận đăng ký",
      text: t("auth_status.rr"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_RRE]: {
      //"Từ chối tiếp nhận thay đổi"
      text: t("auth_status.rre"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_AR]: {
      // Đã tiếp nhận đăng ký
      text: t("auth_status.ar"),
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_ARE]: {
      // Đã tiếp nhận thay đổi
      text: t("auth_status.are"),
      badgeColor: "badge-soft-info",
    },
  };

  const PROGRESS_STATUS = {
    1: {
      //"Lưu tạm",
      text: "Chưa được gửi đi TCT",
      badgeColor: "badge-soft-info",
    },
    2: {
      //"Lưu tạm",
      text: "Đang đính kèm trong 1 bảng tổng hợp",
      badgeColor: "badge-soft-info",
    },
    3: {
      //"Lưu tạm",
      text: "Đã gửi trong 1 bảng tổng hợp",
      badgeColor: "badge-soft-info",
    },
    4: {
      //"Lưu tạm",
      text: "Đã gửi thẳng TCT",
      badgeColor: "badge-soft-info",
    },
  };

  const APPROVE_STATUS = {
    [APPROVE_STATUS_M]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-info",
    },
    [APPROVE_STATUS_P]: {
      //""Gửi chờ duyệt",",
      text: "Gửi chờ duyệt",
      badgeColor: "badge-soft-warning",
    },
    [APPROVE_STATUS_A]: {
      //"Đã duyệt",
      text: "Đã duyệt",
      badgeColor: "badge-soft-success",
    },
    [APPROVE_STATUS_R]: {
      //"Từ chối duyệt",
      text: "Từ chối duyệt",
      badgeColor: "badge-soft-danger",
    },
  };

  const CLIENT_TYPE = {
    [CLIENT_TYPE_CONST.SALE]: {
      text: "HĐ GTGT bình thường",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.SALE_ADJ]: {
      text: "HĐ GTGT Điều chỉnh giảm",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.IBT_GTGT]: {
      text: "PXK trường hợp ngoại tỉnh",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.GRA]: {
      text: "HĐ GTGT Trả hàng cho NCC",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.GRA_ADJ]: {
      text: "HĐ GTGT Trả hàng cho NCC điều chỉnh giảm",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.IBT]: {
      text: "Phiếu xuất kho bình thường",
      badgeColor: "badge-soft-primary",
    },
    [CLIENT_TYPE_CONST.IBT_CSM]: {
      text: "Phiếu xuất kho có hàng consignment",
      badgeColor: "badge-soft-primary",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
    PROGRESS_STATUS: PROGRESS_STATUS,
    APPROVE_STATUS: APPROVE_STATUS,
    CLIENT_TYPE: CLIENT_TYPE,
  };
};

export const operatorsHelper = {
  "+": function (a, b) {
    return a + b;
  },
  "-": function (a, b) {
    return a - b;
  },
};

export const caculateHHDVCommon = ({
  fieldArray,
  index,
  fieldChild,
  customValue,
  HHDV_OBJ,
  getValues,
  isFirstLoad = false,
  setIsFirstLoad = null,
  autoSumGroupAll = null,
  watch,
  setValue,
  OPTION_HHDV_TSUAT,
  pageView,
  isWarehouses = false, // Phiếu xuât kho nội bộ/ gửi bán đại lý
  defaultForeignDecimalScale = 3,
}) => {
  if (isFirstLoad) {
    setIsFirstLoad && setIsFirstLoad(false);
    return;
  }
  const value = getValues(HHDV_OBJ.field);
  const HDDV_OBJ = HHDV_OBJ;
  const THHDVU = HDDV_OBJ.list.THHDVU.field;
  const MHHDVU = HDDV_OBJ.list.MHHDVU.field;
  const SLUONG = HDDV_OBJ.list.SLUONG.field;
  const DVTINH = HDDV_OBJ.list.DVTINH.field;
  const DGIA = HDDV_OBJ.list.DGIA.field;
  const THTIEN = HDDV_OBJ.list.THTIEN.field;
  const TCHAT = HDDV_OBJ.list.TCHAT.field;
  const TTHHDTRUNG = HDDV_OBJ?.list?.TTHHDTRUNG?.field;

  const TSUAT = isWarehouses ? null : HDDV_OBJ.list.TSUAT.field;
  const TLCKHAU = isWarehouses ? null : HDDV_OBJ.list.TLCKHAU.field;
  const STCKHAU = isWarehouses ? null : HDDV_OBJ.list.STCKHAU.field;

  let currentValue = {};
  let decimalScale = getDecimalScaleByUnitCurrency(
    watch(`ttchung_dvtte`)?.value,
    defaultForeignDecimalScale
  );
  if (value) {
    currentValue = value[index];
    switch (fieldChild) {
      case TSUAT:
        autoSumGroupAll && autoSumGroupAll();
      case THTIEN:
        const sluong = watch(`hhdv_obj`)[index]["sluong"];
        const dgia = watch(`hhdv_obj`)[index]["dgia"];
        if (isEmptyNumber(sluong) && isEmptyNumber(dgia)) {
          autoSumGroupAll && autoSumGroupAll();
        }
        break;
      case DGIA:
      case SLUONG:
        // IF co nhap so luong va don gia
        if (currentValue[SLUONG] && currentValue[DGIA]) {
          currentValue[THTIEN] = financial(
            Number(currentValue[SLUONG]) * Number(currentValue[DGIA]),
            decimalScale,
            THTIEN
          );
        } else if (!currentValue[SLUONG] || !currentValue[DGIA]) {
          // IF chưa nhap so luong hoac don gia
          currentValue[THTIEN] = "";
        }
        // Nếu là phiếu xuất kho điều chỉnh thì k tính số lượng
        //   if (
        //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.INCREASE ||
        //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE
        //   ) {
        //     currentValue[THTIEN] = Number(currentValue[DGIA]) * 1;
        //   }
        setValue(
          `${HDDV_OBJ.field}.${index}.${THTIEN}`,
          Number(currentValue[THTIEN]),
          {
            shouldValidate: true,
          }
        );
        autoSumGroupAll && autoSumGroupAll();
        break;
      case STCKHAU:
        currentValue[THTIEN] = currentValue[STCKHAU];
        setValue(HDDV_OBJ.field, value, {
          shouldValidate: true,
        });
        autoSumGroupAll && autoSumGroupAll();
        break;
      case TCHAT:
        currentValue[TTHHDTRUNG] = [];
        if (
          currentValue[TCHAT].value === TCHAT_VALUES.GOODS ||
          currentValue[TCHAT].value === TCHAT_VALUES.PROMOTION ||
          currentValue[TCHAT].value === TCHAT_VALUES.SPECIALIZATION_GOODS
        ) {
          if (!isWarehouses && !currentValue[TSUAT].value) {
            currentValue[TSUAT] = OPTION_HHDV_TSUAT[0];
          }
          currentValue[SLUONG] = currentValue[SLUONG]
            ? currentValue[SLUONG]
            : DEFAULT_NULL_NUMBER;
          currentValue[DGIA] = currentValue[DGIA]
            ? currentValue[DGIA]
            : DEFAULT_NULL_NUMBER;
        }
        if (
          currentValue[TCHAT].value !== TCHAT_VALUES.GOODS &&
          currentValue[TCHAT].value !== TCHAT_VALUES.PROMOTION &&
          currentValue[TCHAT].value !== TCHAT_VALUES.SPECIALIZATION_GOODS
        ) {
          currentValue[SLUONG] = DEFAULT_NULL_NUMBER;
          currentValue[DGIA] = DEFAULT_NULL_NUMBER;
          currentValue[DVTINH] = "";
          currentValue[THTIEN] = DEFAULT_NULL_NUMBER;
          if (!isWarehouses) {
            currentValue[TSUAT] = {
              value: "",
              label: "",
            };
          }
          currentValue[MHHDVU] = "";
        }
        if (!isWarehouses) {
          if (currentValue[TCHAT].value !== TCHAT_VALUES.DISCOUNT) {
            currentValue[STCKHAU] = DEFAULT_NULL_NUMBER;
            currentValue[TLCKHAU] = DEFAULT_NULL_NUMBER;
          }
          if (currentValue[TCHAT].value === TCHAT_VALUES.DISCOUNT) {
            currentValue[STCKHAU] = 0;
            currentValue[TSUAT] = {
              value: "0",
              label: "KCT",
            };
            // currentValue[TSUAT] = {
            //   value: "",
            //   label: "",
            // };
            // currentValue[SLUONG] = 1;
            // currentValue[DGIA] = 1;
          }
        }
        setValue(HDDV_OBJ.field, value, {
          shouldValidate: true,
        });
        autoSumGroupAll && autoSumGroupAll();
        break;
      case MHHDVU:
      case THHDVU: //
        const tchat = currentValue.tchat.value;
        const product = customValue;
        // load thông tin khi chọn hàng hóa dịch vụ có sẵn
        if (product) {
          switch (tchat) {
            case TCHAT_VALUES.GOODS:
            case TCHAT_VALUES.PROMOTION:
            case TCHAT_VALUES.SPECIALIZATION_GOODS:
              //
              if (!currentValue[SLUONG]) {
                currentValue[SLUONG] = 0;
              }
              if (fieldChild === THHDVU) {
                currentValue[MHHDVU] = product.code;
              }
              if (fieldChild === MHHDVU) {
                currentValue[THHDVU] = product.name;
              }

              currentValue[DVTINH] = product.unit;
              currentValue[DGIA] = Number(product.price);

              if (!isWarehouses) {
                // Hóa đơn VAT , tem phiếu mí có thuế suất (nếu k có thì mặc định đầu tiên,
                // do sản phẩm được tạo bên hóa đơn bán hàng k có thuế suất)
                switch (pageView) {
                  case invoicePosPageViewList.PAGE_VAT_INVOICE_HAVE_CODE:
                  case invoicePosPageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE:
                  case invoicePosPageViewList.PAGE_VAT_INVOICE_NONE_CODE:
                  case invoicePosPageViewList.PAGE_INVOICE_TICKETS_NONE_CODE:
                    let tsuat = null;
                    if (product.id_vat) {
                      tsuat = OPTION_HHDV_TSUAT.find(
                        item => Number(item.id) === Number(product.id_vat)
                      );
                    } else if (product.vat_text) {
                      tsuat = OPTION_HHDV_TSUAT.find(
                        item => item.label === product.vat_text
                      );
                      if (!tsuat) {
                        tsuat = {
                          value: Number(
                            product.vat_text.replace(/KHAC:|.00%/g, "")
                          ),
                          label: product.vat_text,
                        };
                      }
                    }
                    currentValue[TSUAT] = tsuat ? tsuat : OPTION_HHDV_TSUAT[0];
                    break;
                  default:
                    break;
                }
              }

              if (currentValue[SLUONG] && currentValue[DGIA]) {
                currentValue[THTIEN] = financial(
                  Number(currentValue[SLUONG]) * Number(currentValue[DGIA]),
                  decimalScale,
                  THTIEN
                );
              } else if (!currentValue[SLUONG] || !currentValue[DGIA]) {
                // IF chưa nhap so luong hoac don gia
                currentValue[THTIEN] = "";
              }
              break;
            case TCHAT_VALUES.DISCOUNT:
              if (fieldChild === THHDVU) {
                currentValue[MHHDVU] = product.code;
              }
              if (fieldChild === MHHDVU) {
                currentValue[THHDVU] = product.name;
              }
              break;
            case TCHAT_VALUES.EXPLAIN:
              break;
            default:
              break;
          }
          setValue(HDDV_OBJ.field, value, {
            shouldValidate: true,
          });
          autoSumGroupAll && autoSumGroupAll();
        }
        break;
      default:
        break;
    }
  }
};
